import { Head, Link } from '@inertiajs/react';

export default function Show({ order, orderedItems }) {
  return (
    <>
      <Head title={`Order #${order.id}`} />

      <div className='mx-auto max-w-4xl px-6 py-8'>
        <div className='mb-6'>
          <Link
            href='/dashboard/orders'
            className='ml-2 rounded-lg py-3 px-5 inline-block font-medium ont-body shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
          >
            ← Back
          </Link>
        </div>

        <div className='bg-white shadow rounded-2xl p-6 mb-8'>
          <h1 className='text-2xl font-bold mb-4 text-gray-700'>
            Order #{order.id}
          </h1>

          <dl className='grid md:grid-cols-2 gap-6'>
            <div>
              <p className='mb-2 text-gray-700'>
                <strong className='font-medium'>Customer:</strong>{' '}
                {order.customer_name}
              </p>
              <p className='mb-2 text-gray-700'>
                <strong className='font-medium'>Phone:</strong>{' '}
                {order.customer_phone}
              </p>
              <p className='mb-2 text-gray-700'>
                <strong className='font-medium'>Address:</strong>{' '}
                {order.customer_address}
              </p>
            </div>

            <div>
              <p className='mb-2 text-gray-700'>
                <strong className='font-medium'>Total Amount:</strong> ₵
                {order.total_amount}
              </p>
              <p className='mb-2 text-gray-700'>
                <strong className='font-medium'>Status:</strong>{' '}
                <span
                  className={`px-3 py-1 rounded-full text-sm font-medium ${
                    order.status === 'pending'
                      ? 'bg-gray-100 text-gray-700'
                      : order.status === 'processing'
                      ? 'bg-yellow-100 text-yellow-700'
                      : order.status === 'shipped'
                      ? 'bg-blue-100 text-blue-700'
                      : order.status === 'delivered'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {order.status}
                </span>
              </p>
            </div>
          </dl>
        </div>

        <div className='bg-white shadow rounded-2xl p-6'>
          <h2 className='text-xl font-bold mb-4 text-gray-700'>Items</h2>

          {orderedItems.length > 0 ? (
            <div className='overflow-x-auto'>
              <table className='w-full border-collapse'>
                <thead>
                  <tr className='bg-gray-100 text-left text-sm font-medium text-gray-700'>
                    <th className='p-3'>Product</th>
                    <th className='p-3 text-center'>Qty</th>
                    <th className='p-3 text-center'>Unit Price (₵)</th>
                    <th className='p-3 text-center'>Total (₵)</th>
                    <th className='p-3'>Ordered At</th>
                  </tr>
                </thead>
                <tbody>
                  {orderedItems.map((item, index) => (
                    <tr
                      key={index}
                      className='border-b hover:bg-gray-50 transition text-gray-700'
                    >
                      <td className='p-3'>{item.product_name}</td>
                      <td className='p-3 text-center'>{item.total_quantity}</td>
                      <td className='p-3 text-center'>{item.item_price}</td>
                      <td className='p-3 text-center'>
                        {item.total_quantity * item.item_price}
                      </td>
                      <td className='p-3'>
                        {new Date(item.created_at).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className='text-gray-500 text-sm '>
              No items found in this order.
            </p>
          )}
        </div>
      </div>
    </>
  );
}
